const siderBar = {
  profile: "Profile",
  history: "History",
  setting: "Setting",
  promotion: "Promotion",
};

export default siderBar;
